import React, { useState } from "react";
import moment from "moment";
import { toast, Flip } from 'react-toastify';
import { useQuery, useSet } from "seed/gql";
import { SET_CHAT } from "seed/gql/queries";
import { Modal } from "seed/helpers"
import l from "components/util/l";
import WSManager from "components/util/ws";
import Chat from "components/presentation/chat/Chat";

const ChatNotifications = ({
  flow,
}) => {

  const userId = sessionStorage.getItem("id");
  const notificationsRoomName = `ASYNC_CHAT_STATUS_${flow.id}`;
  const [selectedChat, setSelectedChat] = useState(null);

  const [callSetRead] = useSet(SET_CHAT);

  const reqAsyncChats = useQuery(`{
    chats {
      id
      createdAt
      settings
    }
  }`, `(flow.id=${flow.id} AND user.id=${userId} AND is_async=true AND is_read=false)`, {
    limit: 1,
    orderBy: "-created_at",
    onCompleted: (data) => {

      if (data.chats && data.chats.length > 0) {

        callSetRead({ id: data.chats[0].id, isRead: true });

        if(Math.abs(moment(data.chats[0].createdAt).diff(moment(), 'minutes')) < 3)
          processNotification(data.chats[0]);
        
      }
        
    }
    
  });

  const processNotification = (chat) => {

    let attrs = {
      className: "mt-7",
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      theme: "light",
      toastId: chat.id,
      transition: Flip,
      type: "info",
      onClick: () => onClickOpenNotification(chat),
    }

    let result = (
      <div className="ml-1" role="button">
        <div>{l("Se ha iniciado una nueva ejecución")}</div>
        <button className="btn btn-sm btn-primary py-1 mt-1">
          {l("Ver detalles%PA106")}
        </button>
      </div>
    );

    if (!toast.isActive(chat.id)) toast(result, attrs);
    else toast.update(chat.id, { ...attrs, render: result });

  }

  const onClickOpenNotification = (chat) =>
    setSelectedChat(chat);

  const onNotificationReceived = () =>
    reqAsyncChats.refetch();

  return (
    <div>

      {
        selectedChat &&
          <Modal
            width={850}
            height={770}
            onClose={() => setSelectedChat(null)}
          >
            <div id="chat-studio-container" className="card h-100">
              <div className="card-body p-1 h-100">
                <Chat
                  flow={flow}
                  chat={selectedChat}
                  currentChat={selectedChat}
                  isExecutionChat={true}
                />
              </div>
            </div>
          </Modal>
      }

      <WSManager
        initialRoom={notificationsRoomName}
        autoSuscribe={true}
        onMessageReceived={onNotificationReceived}
      />

    </div>
  )

};

export default ChatNotifications;